import { useInfiniteQuery } from '@tanstack/react-query';

import { useAPI } from 'src/util/use-api';
import { QUERIES } from 'src/util/globals';

/*
 * Cursor-paginated conversation list. `next_key` is the cursor (same convention
 * as the rest of the app, e.g. Comments). Stable query key: the list is only
 * mounted while the conversations view is open, and re-fetches on mount
 * (default staleTime) so it's fresh each open; call `refetch()` to refresh in
 * place (e.g. on a background update) without discarding loaded pages.
 */
export function useConversations() {
  const { API } = useAPI();

  return useInfiniteQuery({
    queryKey: [QUERIES.ASSISTANT_CONVERSATIONS],
    queryFn: async ({ pageParam }) => {
      const res = await API!.assistantAPI.assistantConversationsList({
        nextKey: pageParam,
      });
      return res.data;
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage?.next_key ?? undefined,
    enabled: Boolean(API),
    refetchOnWindowFocus: false,
  });
}
